import React from 'react';

export class DetailsPlaceholder extends React.Component {
  public render(): JSX.Element {
    return <div data-hook="details-placeholder" />;
  }
}
